























































































import axios from "axios";
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";
import { notifyError, notifySuccess } from "@/common/notify";

import { Document, DocumentAttachment } from "@/interfaces";
import FilePicker from "@/components/FilePicker.vue";
import { createDocument, updateDocument } from "@/services";

const defaultDocument: Document = {
  id: 0,
  name: "",
  attachments: [],
};

const defaultDocumentAttachment: DocumentAttachment = {
  id: 0,
  filename: "Test",
  file: "",
};

@Component({
  components: {
    FilePicker,
  },
})
export default class NewDocumentDialog extends Vue {
  @Ref("new-term-dialog")
  dialog!: QDialog;

  @Ref("file-picker-tpt")
  filePicker!: FilePicker;

  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: Object, required: false })
  document!: Document;

  documentData: Document = { ...defaultDocument };

  attachments: DocumentAttachment[] = [];

  removedAttachments: number[] = [];

  updateAttachment = 0;

  file: any = null;

  loading = false;

  progress = 0;

  showProgress = false;

  // Source of the cancel token used to abort the file upload
  source = axios.CancelToken.source();

  created() {
    if (this.document) {
      this.documentData = Object.assign({}, this.document);
      const filename = this.document.path ? this.document.path.split("/") : [];
      this.attachments = [
        {
          id: this.document.id,
          filename: filename.length > 0 ? filename[filename.length - 1] : "",
          file: this.document.url ? this.document.url : "",
        },
      ];
    }
  }

  addAttachments(file: any) {
    this.file = file;

    const newAttachment: DocumentAttachment = {
      ...defaultDocumentAttachment,
      filename: file.file.name,
      file: `data:${file.file.type};base64,` + file.base64,
    };

    this.attachments = [];
    this.attachments.push({ ...newAttachment });
    this.updateAttachment = 1;
  }

  onUploadProgress(progressEvent: ProgressEvent) {
    const { loaded, total } = progressEvent;
    this.progress = Math.floor((loaded * 100) / total);
  }

  async onSubmit() {
    if (this.updateAttachment !== 0) {
      this.showProgress = true;
    }

    try {
      this.loading = true;
      const documentToAdd: any = {
        ...this.documentData,
        attachments: this.attachments,
        _cancelToken: this.source.token,
      };

      if (this.document) {
        await updateDocument(
          {
            ...documentToAdd,
            updateAttachment: this.updateAttachment,
          },
          this.onUploadProgress,
        );
      } else {
        await createDocument(documentToAdd, this.onUploadProgress);
      }

      notifySuccess("Operazione avvenuta con successo!");
      this.$emit("ok", documentToAdd);
      if (!this.document) {
        this.documentData = { ...defaultDocument };
        this.file = null;
      }
      this.hide();
    } catch (thrown) {
      if (axios.isCancel(thrown)) {
        notifyError("Il caricamento del file è stato interrotto");
      } else {
        notifyError(`Si è verificato un errore durante la ${this.document ? "modifica" : "creazione"} del documento`);
      }
    } finally {
      this.loading = false;
      if (this.attachments.length > 0) {
        this.resetAttachments;
      }
    }
  }

  async onDeleteAttachment() {
    this.attachments = [];
    this.file = null;
    this.filePicker.reset();
  }

  get columns() {
    return [
      {
        name: "filename",
        label: "Nome File",
        align: "left",
        field: "filename",
      },
      /* { name: "delete", align: "center" }, */
    ];
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  resetAttachments() {
    this.attachments = [];
    this.showProgress = false;
    this.progress = 0;
    this.source.cancel();
  }

  onCancelClick() {
    this.hide();
    this.resetAttachments();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
